import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onDismiss", "size", "hideCloseButton"];
import { clsx } from 'clsx';
import { DialogBase } from "../DialogBase";

// ====================== Title component =====================/
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Title = function Title(props) {
  var commonClassNames = 'tw-px-2.4 tw-pt-1.6 tw-pb-1.2 tw-flex tw-gap-1.2 tw-items-center tw-font-subtitle4';
  var borderClassNames = 'tw-border-solid tw-border-b tw-border-neutral-light-400';
  if ('children' in props) {
    var _props$className;
    var containJustify = (_props$className = props.className) === null || _props$className === void 0 ? void 0 : _props$className.includes('tw-justify');
    return /*#__PURE__*/_jsx("div", {
      className: clsx(props.className ? [props.className, commonClassNames] : [commonClassNames, borderClassNames], {
        'tw-justify-start': !containJustify
      }),
      children: props.children
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(commonClassNames, borderClassNames, 'tw-flex-col'),
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-font-subtitle4 tw-mb-[0.2rem]",
      children: props.title
    }), props.subtitle ? /*#__PURE__*/_jsx("div", {
      className: "tw-font-body5",
      children: props.subtitle
    }) : null]
  });
};

// ======================= Body =========================== //

export var Body = function Body(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(className ? className : 'tw-pt-1.2 tw-px-2.4 tw-pb-2.4'),
    children: children
  });
};

// ============================== Actions ============================= //

export var Actions = function Actions(_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  var containJustify = className === null || className === void 0 ? void 0 : className.includes('tw-justify');
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-px-2.4 tw-py-2 tw-flex tw-gap-0.8', className, {
      'tw-justify-end': !containJustify
    }),
    children: children
  });
};

// ============================= Main Component ============================ //

export var DialogRequest = function DialogRequest(_ref3) {
  var children = _ref3.children,
    onDismiss = _ref3.onDismiss,
    size = _ref3.size,
    hideCloseButton = _ref3.hideCloseButton,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_jsx(DialogBase, _objectSpread(_objectSpread({}, rest), {}, {
    onDismiss: onDismiss,
    onEscape: onDismiss,
    hideCloseButton: hideCloseButton,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx({
        'tw-min-w-[56.2rem]': size === 's',
        'tw-min-w-7.2': size === 'm'
      }),
      children: children
    })
  }));
};
DialogRequest.Title = Title;
DialogRequest.Body = Body;
DialogRequest.Actions = Actions;
export default DialogRequest;